import React from 'react';
import OPComponent from './op_component';
import ActionSheetContext from './action_sheet_context';
import { Clipboard, Pressable, Text, StyleSheet } from 'react-native';
import { __WEB__, THEME, COLOR } from '../../constants/styles';

export default class ClipboardTouchable extends OPComponent {
  static contextType = ActionSheetContext;
  constructor(props) {
    super(props);
    this.state = { mouseIsIn: false };
  }

  _canShowActionMenu = () => {
    const actionSheetRef = this.context?.actionSheet;
    return !!actionSheetRef && !!this.props.text;
  };

  onLongPress = () => {
    if (!this._canShowActionMenu()) return;

    let propsOptions = this.props.options || [];

    let options = [
      {
        label: 'Copy Text',
        action: () => {
          if (__WEB__) navigator.clipboard.writeText(this.props.text);
          else Clipboard.setString(this.props.text);
        },
      },
    ].concat(propsOptions);
    const cancelButtonIndex = options.length;

    const actionSheetRef = this.context?.actionSheet;
    actionSheetRef.showActionSheetWithOptions(
      {
        options: options.map((o) => o.label).concat('Cancel'),
        cancelButtonIndex,
      },
      (buttonIndex) => {
        if (options[buttonIndex]) options[buttonIndex].action();
      }
    );
  };

  onHoverIn = () => {
    this.setState({ mouseIsIn: true });
  };
  onHoverOut = () => {
    this.setState({ mouseIsIn: false });
  };

  render() {
    return (
      <Pressable
        onLongPress={this.onLongPress}
        onHoverIn={__WEB__ ? this.onHoverIn : null}
        onHoverOut={__WEB__ ? this.onHoverOut : null}
        {...this.props}
      >
        {this.props.children}
        {!!this.state.mouseIsIn && !!this._canShowActionMenu() && (
          <Pressable
            style={[styles.hoverButtons, this.props.hoverButtonsStyle]}
            onPress={this.onLongPress}
          >
            <Text style={styles.btnText}>•••</Text>
          </Pressable>
        )}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  hoverButtons: {
    position: 'absolute',
    top: -8,
    right: -8,
    width: 36,
    height: 36,
    backgroundColor: COLOR.emphasis,
    borderRadius: 18,
    shadowOpacity: 0.5,
    shadowRadius: 4,
    shadowColor: COLOR.shadow,
    shadowOffset: { height: 0, width: 0 },
    elevation: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnText: {
    fontSize: 16,
    textAlign: 'center',
    color: 'white',
  },
});
